import { z } from "zod";
import { getFirebaseFunctionDefinition } from "../utils/getFirebaseFunctionDefinition";

const AddReactionFeedbackToChatMessageRequest = z.object({
  chatId: z.string(),
  chatMessageId: z.string(),
  reactionFeedback: z.string().nonempty(),
});

const AddReactionFeedbackToChatMessageResponse = z.object({});

export const AddReactionFeedbackToChatMessageDefinition =
  getFirebaseFunctionDefinition({
    path: "/chats/messages/feedback/add",
    reqType: AddReactionFeedbackToChatMessageRequest,
    resType: AddReactionFeedbackToChatMessageResponse,
    isAuthRequired: true,
  });
